import { SVGProps } from "react"

type Props = SVGProps<SVGSVGElement> & {
  size?: number
}

export const IconAppret = ({ size = 24, ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 31 26"
    fill="none"
    {...props}
  >
    <path
      d="M4.84937 4.72347V1.98059"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M4.84937 8.80538V6.0625"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M5.58194 5.39313L8.32471 5.39313"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M1.49991 5.39313L4.24268 5.39313"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M26.0278 14.2005V11.4576"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M26.0278 18.2824V15.5395"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M26.7604 14.8701L29.5032 14.8701"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M22.6784 14.8701L25.4211 14.8701"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M20.5644 10.8057C18.7708 8.3299 16.9014 5.88336 13.7918 5.09741C13.546 5.03528 13.3184 5.23431 13.3127 5.48777C13.2049 10.2391 7.84607 10.5234 5.74945 13.321C5.59044 13.5332 5.72082 13.8248 5.97627 13.8958C6.85226 14.1393 7.61009 14.5086 8.29866 14.9786C11.9442 17.4671 13.7539 21.4107 15.2461 22.7086C15.7445 23.2376 16.2821 23.7706 16.87 24.3017C17.047 24.4617 17.3241 24.4213 17.4657 24.2294C19.06 22.0694 21.2494 21.6492 22.8586 20.4717"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)
